import TrendingVideoPage from './TrendingVideoPage'

export default TrendingVideoPage
